<template>
  <div>
    <!--    기본정보-->
    <field-select-module v-model="form.stdInfo" :options="[
        { type: 'date', label: '점검일'},
        { type: 'text', label: '점검장소'},
        { type: 'disaster', label: '재해형태'}
      ]" :board="this.board" :is-print="isPrint"/>

    <!--    장비정보-->
    <table-equipment
      class="mt-5"
      :list="form.equipmentList"
      @updateList="updateList"
      :isPrint="isPrint"
      :isReadonly="board.readonly"
    ></table-equipment>


    <!--    점검대상-->
    <vs-row class="mt-6">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5>
          <i class="dot"></i> 점검대상
        </h5>
      </vs-col>
    </vs-row>

    <div class="grid grid-cols-1 md:grid-cols-12 gap-x-6 gap-y-4 mt-4">
      <div class="col-span-1 md:col-span-2 flex items-center">
        <!--        체크 1-->
        <div v-if="isPrint" class="flex items-center">
          <div
            v-if="form.check_1"
            style="background: #200c63"
            class="w-5 h-5 rounded-sm text-white flex justify-center items-center mr-2"
          >
            <vs-icon icon="check" size="x-small"></vs-icon>
          </div>
          <div
            v-else
            style="border: 2px solid rgb(180, 180, 180)"
            class="w-5 h-5 rounded-sm mr-2"
          ></div>
          <span class="flex-1">
            {{ inspectionTitle_1 }}
          </span>
        </div>
        <div v-else>
          <span class="flex">
            <vs-checkbox
              :readonly="board.readonly"
              v-model="form.check_1"
            ></vs-checkbox>
         {{inspectionTitle_1}}
          </span>
        </div>
      </div>
      <div class="col-span-2 flex items-center">
        <!--        체크 2-->
        <div v-if="isPrint" class="flex items-center">
          <div
            v-if="form.check_2"
            style="background: #200c63"
            class="w-5 h-5 rounded-sm text-white flex justify-center items-center mr-2"
          >
            <vs-icon icon="check" size="x-small"></vs-icon>
          </div>
          <div
            v-else
            style="border: 2px solid rgb(180, 180, 180)"
            class="w-5 h-5 rounded-sm mr-2"
          ></div>
          <span class="flex-1">
            {{ inspectionTitle_2 }}
          </span>
        </div>
        <div v-else>
          <span class="flex">
            <vs-checkbox
              :readonly="board.readonly"
              v-model="form.check_2"
            ></vs-checkbox>
         {{inspectionTitle_2}}
          </span>
        </div>
      </div>

      <div class="col-span-2 flex items-center">
        <!--        체크 3-->
        <div v-if="isPrint" class="flex items-center">
          <div
            v-if="form.check_3"
            style="background: #200c63"
            class="w-5 h-5 rounded-sm text-white flex justify-center items-center mr-2"
          >
            <vs-icon icon="check" size="x-small"></vs-icon>
          </div>
          <div
            v-else
            style="border: 2px solid rgb(180, 180, 180)"
            class="w-5 h-5 rounded-sm mr-2"
          ></div>
          <span class="flex-1">
            {{ inspectionTitle_3 }}
          </span>
        </div>
        <div v-else>
          <span class="flex">
            <vs-checkbox
              :readonly="board.readonly"
              v-model="form.check_3"
            ></vs-checkbox>
         {{inspectionTitle_3}}
          </span>
        </div>
      </div>
      <div class="col-span-2 flex items-center">
        <!--        체크 4-->
        <div v-if="isPrint" class="flex items-center">
          <div
            v-if="form.check_4"
            style="background: #200c63"
            class="w-5 h-5 rounded-sm text-white flex justify-center items-center mr-2"
          >
            <vs-icon icon="check" size="x-small"></vs-icon>
          </div>
          <div
            v-else
            style="border: 2px solid rgb(180, 180, 180)"
            class="w-5 h-5 rounded-sm mr-2"
          ></div>
          <span class="flex-1">
            {{ inspectionTitle_4 }}
          </span>
        </div>
        <div v-else>
          <span class="flex">
            <vs-checkbox
              :readonly="board.readonly"
              v-model="form.check_4"
            ></vs-checkbox>
         {{inspectionTitle_4}}
          </span>
        </div>
      </div>
    </div>

    <table-inspect
      class="mt-5"
      :is-print="isPrint"
      :is-readonly="board.readonly"
      :is-show-title="true"
      :title="inspectionTitle_1"
      :list="form.inspectList_1"
      @update-list-check="updateListCheck_1"
      v-if="form.check_1"
    />

    <table-inspect
      class="mt-5"
      :is-print="isPrint"
      :is-readonly="board.readonly"
      :is-show-title="true"
      :title="inspectionTitle_2"
      :list="form.inspectList_2"
      @update-list-check="updateListCheck_2"
      v-if="form.check_2"
    />

    <table-inspect
      class="mt-5"
      :is-print="isPrint"
      :is-readonly="board.readonly"
      :is-show-title="true"
      :title="inspectionTitle_3"
      :list="form.inspectList_3"
      @update-list-check="updateListCheck_3"
      v-if="form.check_3"
    />

    <table-inspect
      class="mt-5"
      :is-print="isPrint"
      :is-readonly="board.readonly"
      :is-show-title="true"
      :title="inspectionTitle_4"
      :list="form.inspectList_4"
      @update-list-check="updateListCheck_4"
      v-if="form.check_4"
    />

    <!--    사진대지-->
    <PhotoUploadGridModule
      :row-count="2"
      :grid-count="2"
      v-model="form.photoList"
      :is-print="isPrint"
      :readonly="board.readonly"
      section-title="사진대지"
      placeholder="신축현장 점검"/>

    <!--    파일첨부-->
    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>

  </div>
</template>

<script>
import FieldSelectModule from '@/views/modules/FieldSelectModule'
import PhotoUploadGridModule from '@/views/modules/PhotoUploadGridModule'
import PopupPlanProject from '@/views/project/popup/PopupPlanProject'
import DateSelector from '@/components/selector/DateSelector'
import PopupProjectSetting from '@/views/project/PopupProjectSetting'
import MemberSelector from '@/components/selector/MemberSelector'
import CompanySelector from '@/components/selector/CompanySelector'
import FileUploader from '@/components/FileUploader'
import FileUploadModule from '@/views/modules/FileUploadModule'
import TableInspect from '@/components/TableInspect'
import TableEquipment from '@/components/TableEquipment'
import DisasterClassSelector from '@/components/selector/DisasterClassSelector'

export default {
  components: {
    FileUploadModule,
    TableInspect,
    TableEquipment,
    DisasterClassSelector,
    FileUploader,
    CompanySelector,
    MemberSelector,
    PopupProjectSetting,
    DateSelector,
    PopupPlanProject,
    FieldSelectModule,
    PhotoUploadGridModule
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler (value) {
        const keys = Object.keys(this.form)
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key]
          }
        }

        if (!this.form || !this.form.inspectList_1 || this.form.inspectList_1.length === 0) {
          this.form.inspectList_1 = this.inspectTable_1
        }
        if (!this.form || !this.form.inspectList_2 || this.form.inspectList_2.length === 0) {
          this.form.inspectList_2 = this.inspectTable_2
        }
        if (!this.form || !this.form.inspectList_3 || this.form.inspectList_3.length === 0) {
          this.form.inspectList_3 = this.inspectTable_3
        }
        if (!this.form || !this.form.inspectList_4 || this.form.inspectList_4.length === 0) {
          this.form.inspectList_4 = this.inspectTable_4
        }
      }
    },
    form: {
      immediate: true,
      deep: true,
      handler (value) {
        this.form.inspectionTitle
          = `${value.check_1 ? this.inspectionTitle_1 : ''}
            ${value.check_2 ? this.inspectionTitle_2 : ''}
            ${value.check_3 ? this.inspectionTitle_3 : ''}
            ${value.check_4 ? this.inspectionTitle_4 : ''}`

        this.$emit('input', value)
      }
    }
  },
  data () {
    return {
      inspectionTitle_1:'일반',
      inspectionTitle_2:'굴착사면',
      inspectionTitle_3:'흙막이 가시설',
      inspectionTitle_4:'거푸집 동바리',

      form: {
        inspectionTitle:'',
        stdInfo: { },
        photoList: [],
        check_1: true,
        check_2: false,
        check_3: false,
        check_4: false,
        fileList: [],
        equipmentList: [],
        inspectList_1: [],
        inspectList_2: [],
        inspectList_3: [],
        inspectList_4: [],
      },
    }
  },
  computed: {
    inspectTable_1 () {
      return [
        {
          id: 1,
          label: '지반의 붕괴 위험을 방지하기 위하여 지반을 안전한 경사로 하고 빗물이나 지하수 등을 배제하고 적절히 지보공을 설치하는 등 필요한 조치를 한다.',
          is_checked: '',
          title: '지반 안전성 확보',
        },
        {
          id: 2,
          label: '급작스런 지하수위 상승 등 지반의 변화가 있을 경우 전문가 검토를 통해 안전을 확보한다.',
          is_checked: '',
          title: '지반 안전성 확보',
        },
        {
          id: 3,
          label: '동절기, 해빙기, 장마철 등 취약시기에 대비하여 안전계획을 수립한다.\n' +
            '       *동절기 : 지반의 동결·팽창에 따른 비탈면, 흙막이 구조물 붕괴 \n' +
            '         해빙기 : 동결된 지반이 융해되어 침하되면서 구조물을 약화시켜 붕괴         장마철 : 지속적인 강우로 토압이 증가하여 흙막이 등 지반 붕괴',
          is_checked: '',
          title: '취약시기 대비',
        },

      ]
    },
    inspectTable_2 () {
      return [
        {
          id: 1,
          label: '굴착장소 및 그 주변의 지반 및 지하매설물에 대하여 사전에 조사하여야 한다.',
          is_checked: '',
          title: '사전 조사 적정성',
        },
        {
          id: 2,
          label: '장비의 진입로와 작업장에서의 주행로를 확보하고, 다짐도, 노폭, 경사도 등의 상태를 점검하여야 한다.',
          is_checked: '',
          title: '사전 조사 적정성',
        },
        {
          id: 3,
          label: '굴착사면 설계시 활동면의 전단강도와 전단응력에 대한 기준안전율을 확보하여야 한다. ',
          is_checked: '',
          title: '사전 설계 적정성',
        },
        {
          id: 4,
          label: '기준 안전율 확보 불가시 앵커, 네일 등 사면 보강을 실시하고, 불가시 흙막이 벽체공법 등으로 굴착공법을 변경하여야 한다.',
          is_checked: '',
          title: '사전 설계 적정성',
        },
        {
          id: 5,
          label: '기존 구조물 근접 굴착시 흙막이 벽체 공법 등으로 굴착 공법을 변경하여야 한다.',
          is_checked: '',
          title: '사전 설계 적정성',
        },
        {
          id: 6,
          label: '지반의 종류에 따라 굴착면의 기울기를 준수하여야 한다.',
          is_checked: '',
          title: '굴착작업 시 안전대책',
        },
        {
          id: 7,
          label: '트랜치 굴착시 굴착사면 기울기 확보가 불가한 경우 간이 흙막이를 설치하여야 한다. ',
          is_checked: '',
          title: '굴착작업 시 안전대책',
        },
        {
          id: 8,
          label: '간이 흙막이는 지하 매설물과 간섭이 없는 구조로 하여야 한다.',
          is_checked: '',
          title: '굴착작업 시 안전대책',
        },
        {
          id: 9,
          label: '굴착 토사나 차량 등 경사면 및 굴착부 배면에 재하시 최소 이격거리를 확보하여야 한다.',
          is_checked: '',
          title: '굴착완료 후 안전대책',
        },
        {
          id: 10,
          label: '용수가 발생한 때에는 신속하게 배수하여야 하며 굴착사면에 우수 등이 유입되지 않도록 차수시설을 하여야 한다.',
          is_checked: '',
          title: '굴착완료 후 안전대책',
        },
      ]
    },
    inspectTable_3 () {
      return [
        {
          id: 1,
          label: '엄지말뚝 설치 위치에 가스관, 상·하수도관 등 장애물의 유무를 유관기관의 설계도서 등으로 조사한 후 인력굴착으로 확인하여야 하며 필요시 이설 등대책을 수립하여야 한다.',
          is_checked: '',
          title: '사전 조사 적정성',
        },
        {
          id: 2,
          label: '인접하여 지하 굴착 및 흙막이 공사현장이 있을 경우 당해 흙막이 공사에 미칠 영향을 조사한 후 대책을 수립하여야 한다.',
          is_checked: '',
          title: '사전 조사 적정성',
        },
        {
          id: 3,
          label: '시공 전에 엄지말뚝, 토류판, 버팀대, 중간말뚝, 귀잡이, 띠장 등 흙막이의 각 부재가 설계도서에 명시한 규격 및 재질과 부합여부, 단면손상여부, 구부러짐 정도 등을\n' +
            '       점검하고 이상 유무를 확인하여야 한다.',
          is_checked: '',
          title: '자재 및 재료의 적정성',
        },
        {
          id: 4,
          label: '엄지말뚝의 선단은 설계도서에 의거 충분한 근입깊이를 확보하여야 한다.',
          is_checked: '',
          title: '가설치작업 시 안전대책',
        },
        {
          id: 5,
          label: '엄지말뚝은 흙막이 배면부 지반 높이 보다 높게 시공하고 동 위치에 발끝막이판을 설치하는 등 흙막이 상단부의 지표수 유입방지, 낙석, 낙하 발생방지를 위한 필요한 조치를 하여야 한다.',
          is_checked: '',
          title: '설치작업 시 안전대책',
        },
        {
          id: 6,
          label: '흙막이 가시설 배면부의 흙막이 높이에 해당하는 범위 내에서는 각종 차량과 토사 및 재료가 적치되지 않도록 계획을 수립하고, 부득이 적재 시는 별도의  하중 검토 등 안전성을 확인하여야 한다.',
          is_checked: '',
          title: '설치완료 후 안전대책',
        },
        {
          id: 7,
          label: '엄지말뚝을 설치 후 천공 구멍은 양질의 토사, 모래, 소일 시멘트 등으로 완전히 충진시킨 후에 후속공정을 진행하여야 한다. ',
          is_checked: '',
          title: '설치완료 후 안전대책',
        },

      ]
    },
    inspectTable_4 () {
      return [
        {
          id: 1,
          label: '파이프 서포트 동바리 재료는 변형·부식 또는 심하게 손상된 것을 사용해서는 아니 된다.',
          is_checked: '',
          title: '자재 및 재료의 적정성',
        },
        {
          id: 2,
          label: '장선 및 멍에는 거푸집 널과 원활히 결합될 수 있는 재료나 결합방식을 고려하여 선정하여야 한다.',
          is_checked: '',
          title: '자재 및 재료의 적정성',
        },
        {
          id: 3,
          label: '파이프 서포트 동바리는 구조를 검토한 후 조립도를 작성하고, 조립도에 따라 조립하여야 한다.',
          is_checked: '',
          title: '사전 설계 적정성',
        },
        {
          id: 4,
          label: '조립도에는 동바리·멍에 등 부재의 재질·단면규격·설치간격 및 이음방법 등을 명시하여야 한다.',
          is_checked: '',
          title: '사전 설계 적정성',
        },
        {
          id: 5,
          label: '거푸집 동바리는 시공전 조립·콘크리트 타설·해체 계획과 안전시공 절차 등 시공계획을 수립하여야 한다.',
          is_checked: '',
          title: '설치작업 시 안전대책',
        },
        {
          id: 6,
          label: '동바리를 지반에 설치하는 경우에는 침하를 방지하기 위하여 콘크리트를 타설하거나, 두께 45 mm 이상의 깔목, 깔판, 전용 받침 철물, 받침판 등을  설치하여야 한다.',
          is_checked: '',
          title: '설치작업 시 안전대책',
        },
        {
          id: 7,
          label: '높이 2미터 이내마다 수평연결재를 2개 방향으로 설치하고 수평연결재의 변위를 방지 해야한다.',
          is_checked: '',
          title: '설치작업 시 안전대책',
        },
        {
          id: 8,
          label: '콘크리트 타설작업 시 콘크리트 타설순서 등 타설계획을 수립하여야 한다.',
          is_checked: '',
          title: '콘크리트 타설작업 시 안전대책',
        },
        {
          id: 9,
          label: '콘크리트 타설작업 시 편심이 발생하지 않도록 분산하여 타설하여야 한다. ',
          is_checked: '',
          title: '콘크리트 타설작업 시 안전대책',
        },

      ]
    },
  },
  methods : {
    updateList (list) {
      this.form.equipmentList = list
    },
    updateListCheck_1 (indexRows, text) {
      this.form.inspectList_1[indexRows].is_checked = text
    },
    updateListCheck_2 (indexRows, text) {
      this.form.inspectList_2[indexRows].is_checked = text
    },
    updateListCheck_3 (indexRows, text) {
      this.form.inspectList_3[indexRows].is_checked = text
    },
    updateListCheck_4 (indexRows, text) {
      this.form.inspectList_4[indexRows].is_checked = text
    },
  }
}
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}
.mt-component-form {
  margin-top: 15px;
}

/* uploaded File */
.h-upload {
  height: 470px;
}
.upload-content {
  border: $border;
  &:last-child {
    border-left: none;
  }
  &__title {
    height: 54px;
    line-height: 54px;
    text-align: center;
    background: #fafafa;
    border-bottom: $border;
  }
  &__input {
    height: 54px;
    background: #f9f9f9;
    border-top: $border;
    padding: 5px 15px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &__file {
    height: calc(100% - 54px);
    width: 100%;
    padding: 14px;
  }
}
</style>
